import React from 'react'
import Defaultloadinggif from '../../layout/Others/Defaultloadinggif';

const NoRecordTable = ({ result, loader }) => {
  return (
    <div className="noRecord">
      {loader ? (
        <label> <Defaultloadinggif /></label>) :
        (result <= 0 && (<p className=" theme-text-color"> No data Available!  </p>))}
    </div>
  )
}

export default NoRecordTable